import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Col, Row, Button } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import { concatenateNames } from '../../Utils/Patient';

const FormClientInvoice = ({
    typeClient,
    client,
    handleTypeClient,
    handleClient,
    errors,
    cleanDataPatient
}) => {

    const [countries, setCountries] = useState([]);
    const [departaments, setDepartaments] = useState([]);
    const [cities, setCities] = useState([]);

    const loadPatient = async (num_document) => {
        var dataQuery = { num_documento: num_document };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataQuery)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error consultando el Paciente");
            }
        }).then(data => {
            if (data.existe == true) {
                console.log(data.contenido[0]);
                let nombre_paciente = concatenateNames(data.contenido[0].nombres, data.contenido[0].apellido1, data.contenido[0].apellido2);
                handleClient(data.contenido[0].tip_documento, "type_document");
                handleClient(nombre_paciente, "name");
                handleClient(data.contenido[0].direccion.direccion, "adress");
                handleClient(data.contenido[0].direccion.id_pais, "country");
                handleClientDepartament(data.contenido[0].direccion.id_departamento, "departament");
                handleClient(data.contenido[0].direccion.id_ciudad, "city");
                handleClient(data.contenido[0].celular, "phone");
                handleClient(data.contenido[0].correo, "email");
            }
        }).catch((error) => {
            console.log("dataPatient", error);
        });
    }

    const loadThird = async (num_document) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/consultar-x-nit?nit='+num_document, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error consultando el Tercero");
            }
        }).then(data => {
            console.log(data);
            if (data.tercero != null && data.tercero != undefined && data.tercero != "") {
                console.log("TERCERO",data.tercero);
                handleClient("NIT", "type_document");
                handleClient(data.tercero.nombre, "name");
                handleClient(data.tercero.direccion.direccion, "adress");
                handleClient(data.tercero.direccion.id_pais, "country");
                handleClientDepartament(data.tercero.direccion.id_departamento, "departament");
                handleClient(data.tercero.direccion.id_ciudad, "city");
                handleClient(data.tercero.telefono, "phone");
                handleClient(data.tercero.correo, "email");
            }
        }).catch((error) => {
            console.log("dataPatient", error);
        });
    }

    const loadContries = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paises/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error consultando los Paises");
            }
        }).then(data => {
            setCountries(data);
        }).catch((error) => {
            console.error('Error:', error);
            setCountries([]);
        });
    }

    const loadDepartaments = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error consultando los Paises");
            }
        }).then(data => {
            setDepartaments(data);
        }).catch((error) => {
            console.error('Error:', error);
            setDepartaments([]);
        });
    }

    const loadCities = async (depcod) => {
        var data = { id_dpto: depcod };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error listando las Ciudades")
            }
        }).then(data => {
            setCities(data);
        }).catch((error) => {
            setCities([])
            console.error('Error:', error);
        });
    }

    const loadClientInformation = async (num_document) => {
        switch (typeClient) {
            case "NATURAL": //Realiza la Busqueda de Pacientes
                await loadPatient(num_document);
                break;
            case "JURIDICA": //Realiza la Busqueda de Terceros
                console.log("TerceroJURIDICAXD");
                await loadThird(num_document);
                break;
        }
    }

    const cleanPatientData = () => {
        handleClientDepartament(null, "departament");
        cleanDataPatient();       
    }

    const handleClientDepartament = async (value) => {
        await handleClient(null, "city");
        await loadCities(value);
        await handleClient(value, "departament");
    }

    useEffect(() => {
        loadContries();
        loadDepartaments();
    }, []);

    return (
        <Row>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    select
                    name="type_client"
                    id="type_client"
                    label="Tipo de Cliente"
                    value={typeClient}
                    onChange={(e) => {
                        handleTypeClient(e.target.value);
                        cleanPatientData();
                    }}
                    error={errors.hasOwnProperty("typeClient") && (typeClient == "" || typeClient == null || typeClient == undefined) ? errors.typeClient !== "" : false}
                    helperText={errors.typeClient}
                >
                    <MenuItem key={1} value={"NATURAL"}>PERSONA NATURAL</MenuItem>
                    <MenuItem key={2} value={"JURIDICA"}>PERSONA JURIDICA</MenuItem>
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    name="num_document_client"
                    id="num_document_client"
                    label={typeClient == "NATURAL" || typeClient == null ? "Número de Documento" : "Número de Documento o NIT"}
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.num_document}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.num_document != null && client.num_document != undefined && client.num_document != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "num_document");
                        loadClientInformation(e.target.value);
                    }}
                    error={errors.hasOwnProperty("num_document") && (client.num_document == "" || client.num_document == null || client.num_document == undefined) ? errors.num_document !== "" : false}
                    helperText={errors.num_document}
                >
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    name="type_document"
                    id="type_document"
                    label="Tipo de Documento"
                    select
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.type_document}
                    onChange={(e) => {
                        handleClient(e.target.value, "type_document");
                    }}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.type_document != null && client.type_document != undefined && client.type_document != "" ? true : false
                    }}
                    error={errors.hasOwnProperty("type_document") && (client.type_document == "" || client.type_document == null || client.type_document == undefined) ? errors.type_document !== "" : false}
                    helperText={errors.type_document}
                >
                    <MenuItem key={1} value={'TI'}>TI-Tarjeta de Identidad</MenuItem>
                    <MenuItem key={2} value={'CC'}>CC-Cedula de Ciudadania</MenuItem>
                    <MenuItem key={3} value={'PA'}>PA-Pasaporte</MenuItem>
                    <MenuItem key={4} value={'RC'}>RC-Registro Civil</MenuItem>
                    <MenuItem key={5} value={'CE'}>CE-Cedula de Extranjeria</MenuItem>
                    <MenuItem key={6} value={'MS'}>MS-Menor sin Identificación</MenuItem>
                    <MenuItem key={7} value={'AS'}>AS-Adulto sin Identificación</MenuItem>
                    <MenuItem key={8} value={'SC'}>SC-Salvo Conducto</MenuItem>
                    <MenuItem key={9} value={'CD'}>CD-Carnet Diplomatico</MenuItem>
                    <MenuItem key={10} value={'CN'}>CN-Certificado de Nacido Vivo</MenuItem>
                    <MenuItem key={11} value={'NIT'}>NIT</MenuItem>
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    name="name_client"
                    id="name_client"
                    label="Nombre"
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.name}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.name != null && client.name != undefined && client.name != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "name");
                    }}
                    error={errors.hasOwnProperty("name") && (client.name == "" || client.name == null || client.name == undefined) ? errors.name !== "" : false}
                    helperText={errors.name}
                />
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    name="phone-client"
                    id="phone-client"
                    label="Telefono"
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.phone}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.phone != null && client.phone != undefined && client.phone != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "phone");
                    }}
                    error={errors.hasOwnProperty("phone") && (client.phone == "" || client.phone == null || client.phone == undefined) ? errors.phone !== "" : false}
                    helperText={errors.phone}
                />
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    name="email-client"
                    id="email-client"
                    label="Correo Electronico"
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.email}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.email != null && client.email != undefined && client.email != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "email");
                    }}
                    error={errors.hasOwnProperty("email") && (client.email == "" || client.email == null || client.email == undefined) ? errors.email !== "" : false}
                    helperText={errors.email}
                />
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    label="País"
                    id="id-simplepais-select"
                    select
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.country}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.country != null && client.country != undefined && client.country != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "country");
                    }}
                    error={errors.hasOwnProperty("country") && (client.country == "" || client.country == null || client.country == undefined) ? errors.country !== "" : false}
                    helperText={errors.country}
                >
                    {countries.map((country) => {
                        return <MenuItem className="material-form__option" key={country.paicod} value={country.paicod}>{country.painom}</MenuItem>
                    })}
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    label="Departamento"
                    id="id-simpledpto-select"
                    select
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.departament}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.departament != null && client.departament != undefined && client.departament != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClientDepartament(e.target.value);
                    }}
                    error={errors.hasOwnProperty("departament") && (client.departament == "" || client.departament == null || client.departament == undefined) ? errors.departament !== "" : false}
                    helperText={errors.departament}
                >
                    {departaments.map((departament) => {
                        return <MenuItem className="material-form__option" key={departament.depcod} value={departament.depcod}>{departament.depnom}</MenuItem>
                    })}
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    label="Ciudad"
                    id="id-simplecity-select"
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    select
                    value={client.city}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.city != null && client.city != undefined && client.city != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "city");
                    }}
                    error={errors.hasOwnProperty("city") && (client.city == "" || client.city == null || client.city == undefined) ? errors.city !== "" : false}
                    helperText={errors.city}
                >
                    {cities.map((city) => {
                        return <MenuItem className="material-form__option" key={city.ciucod} value={city.ciucod}>{city.ciunom}</MenuItem>
                    })}
                </TextField>
            </Col>
            <Col md={4}>
                <TextField
                    className="medical-material-form__field"
                    label="Dirección"
                    id="id-simpleadresss-select"
                    disabled={typeClient == null || typeClient == undefined || typeClient == "" ? true : false}
                    value={client.adress}
                    InputLabelProps={{
                        style: { color: '#646777' },
                        shrink: client.adress != null && client.adress != undefined && client.adress != "" ? true : false
                    }}
                    onChange={(e) => {
                        handleClient(e.target.value, "adress");
                    }}
                    error={errors.hasOwnProperty("adress") && (client.adress == "" || client.adress == null || client.adress == undefined) ? errors.adress !== "" : false}
                    helperText={errors.adress}
                />
            </Col>
        </Row>
    );
};
export default FormClientInvoice;
